export const CHAT_HISTORY_REQUEST = "CHAT_HISTORY_REQUEST";
export const CHAT_HISTORY_RESPONSE = "CHAT_HISTORY_RESPONSE";
export const CLOSE_CHAT_HISTORY = "CLOSE_CHAT_HISTORY";
export const OPEN_CHAT_HISTORY = "OPEN_CHAT_HISTORY";
export const CHAT_PAGINATION = "CHAT_PAGINATION";
export const ADD_NEW_CHAT_MESSAGE = "ADD_NEW_CHAT_MESSAGE";

